<app-content-card
  [icon]="icon()"
  [iconColor]="iconColor()"
  [iconBackgroundColor]="iconBackgroundColor()"
  [borderColor]="cardBorderColor()"
  [backgroundColor]="cardBackgroundColor()"
  [title]="title() | translateLang"
  [subtitle]="subtitle() ? (subtitle()! | translateLang) : undefined">
  @if (badgeLabel()) {
    <app-badge
      rightContent
      [label]="badgeLabel()!"
      [variant]="badgeVariant()">
    </app-badge>
  }

  <div class="currency-management__body">
    <div class="currency-management__selector-wrapper">
      <div
        class="currency-management__selector"
        (click)="toggleDropdown()"
        role="button"
        tabindex="0"
        [attr.aria-expanded]="isDropdownOpen()"
        [attr.aria-label]="'fund.currency_management.select_currency' | translateLang">
        <div class="currency-management__selected">
          <span class="currency-management__selected-label">
            {{ selectedCurrency() ? getFormattedCurrencyDisplay() : ('fund.currency_management.select_currency' | translateLang) }}
          </span>
        </div>
        <app-caret-icon
          [isOpen]="isDropdownOpen()"
          [color]="'#464648'">
        </app-caret-icon>
      </div>

      <div
        #dropdownWrapper
        class="currency-management__dropdown"
        [class.currency-management__dropdown--above]="dropdownOpenAbove()">
        <app-dropdown
          [items]="displayCurrencies()"
          [isOpen]="isDropdownOpen()"
          [selectedItem]="selectedCurrency()"
          [maxHeight]="maxDropdownHeight()"
          [openAbove]="dropdownOpenAbove()"
          (itemSelected)="onCurrencySelected($event)"
          (closed)="closeDropdown()">
        </app-dropdown>
      </div>
    </div>

    @if (balance()) {
      <div class="currency-management__balance-row">
        <div class="currency-management__balance-left">
          <app-currency-indicator
            [currencyCode]="getSelectedCurrencyCode()"
            [countryCode]="getSelectedCountryCode()"
            [showText]="false"
            variant="black">
          </app-currency-indicator>
          <span class="currency-management__balance-currency-code">{{ getSelectedCurrencyCode() }}</span>
        </div>
        <span
          class="currency-management__balance-amount"
          [class.currency-management__balance-amount--long]="balanceSizeTier() === 'long'"
          [class.currency-management__balance-amount--longer]="balanceSizeTier() === 'longer'">
          {{ balance() }}
        </span>
      </div>
    }
  </div>
</app-content-card>
